import { Icon, TableBody, TableItem, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';
import { columnWidthsCheckingAccount } from '../../constants';

import { CheckingAccountItemTypes } from '.';

export const CheckingAccountItemDesktop: React.FC<CheckingAccountItemTypes.Props> = ({
  item,
  onSelectAccount,
}) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);
  const isValuePositive = item.operationValueNormalized > 0;

  const balanceColor = useMemo(() => {
    if (!valueVisibility) {
      return 'neutral.darkest';
    }

    return item.operationValueNormalized > 0
      ? 'feedback.success.default'
      : 'feedback.error.default';
  }, [valueVisibility, item]);

  return (
    <TableBody testID="table-body">
      <TableItem
        align="center"
        width={columnWidthsCheckingAccount.date}
        testId="header-settlement-date">
        <Text color={'neutral.darkest'} variant="semibold">
          {item.relatedDateNormalized}
        </Text>
      </TableItem>
      <TableItem
        width={columnWidthsCheckingAccount.client}
        testId="header-settlement-client"
        onPress={() => onSelectAccount(item.customerAccountNumber)}>
        <Text color={'neutral.darkest'} variant="regular">
          {item.customerNameNormalized}
        </Text>
      </TableItem>
      <TableItem
        align="center"
        width={columnWidthsCheckingAccount.kind}
        testId="header-balance-estimation">
        <HStack space={Spacing['stack.quarck']} alignItems="center">
          <Text color="neutral.darkest" variant="regular">
            {isValuePositive ? 'ENTRADA' : 'SAÍDA'}
          </Text>
          <Icon
            name={isValuePositive ? 'ArrowDown' : 'ArrowUp'}
            color={Color[isValuePositive ? 'feedback.success.default' : 'feedback.error.default']}
            size="xxs"
          />
        </HStack>
      </TableItem>
      <TableItem align="center" width={columnWidthsCheckingAccount.value} testId="header-value">
        <Text
          color={balanceColor}
          variant="semibold"
          fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
          letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
          {valueVisibility
            ? Utils.Mask.Money(item.operationValueNormalized)
            : Typography['bullet.sequence']}
        </Text>
      </TableItem>
    </TableBody>
  );
};
